import { useEffect, useState } from 'react';
import { StorefrontTheme } from '../lib/storefrontTheme';

export function useStorefrontFonts(href?: string | null) {
  useEffect(() => {
    if (!href) return;
    const link = document.createElement('link'); link.rel = 'stylesheet'; link.href = href;
    document.head.appendChild(link);
    return () => link.remove();
  }, [href]);
}

export function useStorefrontBranding(physicianId?: string) {
  const [branding, setBranding] = useState<{ physicianId: string; name: string; membershipEnabled?: boolean; theme: StorefrontTheme | null }>();
  useEffect(() => {
    if (!physicianId) return;
    const controller = new AbortController();
    fetch(`/api/dtp/branding/${encodeURIComponent(physicianId)}`, { signal: controller.signal }).then(async response => {
      if (!response.ok) return;
      const result = await response.json();
      if (result.success && !controller.signal.aborted) setBranding({ ...result.data, physicianId });
    }).catch(() => {});
    return () => controller.abort();
  }, [physicianId]);
  return branding?.physicianId === physicianId ? branding : undefined;
}

export function useStorefrontPageIdentity(name?: string, theme?: StorefrontTheme | null) {
  useEffect(() => {
    if (!name) return;
    const previousTitle = document.title;
    document.title = name;
    const previousIcons = Array.from(document.querySelectorAll<HTMLLinkElement>('link[rel="icon"]'));
    const originals = previousIcons.map(icon => icon.href);
    let icon: HTMLLinkElement | undefined;
    if (theme?.faviconUrl) {
      previousIcons.forEach(existing => { existing.href = theme.faviconUrl!; });
      if (!previousIcons.length) {
        icon = document.createElement('link'); icon.rel = 'icon'; icon.href = theme.faviconUrl;
        document.head.appendChild(icon);
      }
    }
    return () => { document.title = previousTitle; previousIcons.forEach((existing, i) => { existing.href = originals[i]; }); icon?.remove(); };
  }, [name, theme?.faviconUrl]);
}
